import { SearchOutlined } from "@ant-design/icons";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import { formatCreateDate} from "@utils/helpers";
import { Button, Card, Col, Input, Row, Space, Table, Tooltip } from "antd";
import { cloneDeep, forEach, get, map } from "lodash";
import React, { FC, useEffect, useRef, useState } from "react";
import Highlighter from "react-highlight-words";
import "./appointmentInfo.scss";
import { TableLocale } from "@components/noDataFound";

type TAppointInfo = {
  appointmentInfoLoading?: boolean;
  patientDayAppointmentDetails?: any;
}

const dateDiv = (
  text: any,
  searchWord: any,
  record : any
) => {
  return (
    <Tooltip placement="topLeft" title={text ? formatCreateDate(text) : ""}>
       {formatCreateDate(text)}
    </Tooltip>
  );
}

const highlighterDiv = (
  text: any,
  searchWord: any,
  record : any
) => {

      return (
        <Tooltip placement="topLeft" title={text ? text.toString() : ""}>
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[searchWord]}
              autoEscape
              textToHighlight={text ? text.toString() : ""}
            />
        </Tooltip>
      );
  
};

const TablePreloader = () => {
  return (
    <Row className="tableWrapper">
      <Col span={24}>
        <div className="table-preloader">
          {map(Array.from(Array(6).keys()), (item: any) => {
            return (
              <div className="table-preloader__row" key={"row_" + item}>
                {map(Array.from(Array(6).keys()), (item: any) => {
                  return (
                    <div key={"col_" + item} className="table-preloader__row__column">
                      <div className="table-preloader__row__column__sub-title shimmerBG"></div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
        <div className="pagination_preload">
          <div className="pagination_text_preloader shimmerBG"></div>
        </div>
      </Col>
    </Row>
  );
};

const AppointmentInfo: FC<TAppointInfo> = ({appointmentInfoLoading , patientDayAppointmentDetails}: TAppointInfo) => {
  const [data, setData] = useState<any>();
  const [appointmentInfodata, setAppointmentInfodata] = useState<any>();
  const [columnSearchInfo, setColumnSearchInfo] = useState({});
  const [column , setColumn] = useState<any>();
  const selectedDateCalender = useCalenderViewStore((state) => state.selectedDateCalender);
  const [totalAppointmentAmount, setTotalAppointmentAmount] = useState(0);

  useEffect(() => {
    console.log("AppointmentInfo.useEffect");
    const tempcoldata : any = [];
      forEach(patientDayAppointmentDetails[0], (patientProperties) => {
        let appObj = {
          title: "",
          dataIndex: "",
          key: "",
          width: 160,
          ellipsis: {
            showTitle: false,
          },
          render: (text: any) => (
            <Tooltip placement="topLeft" title={text}>
              {text}
            </Tooltip>
          ),
          sorter: (a: any, b: any) => {
            a[appObj.dataIndex]=a[appObj.dataIndex]?a[appObj.dataIndex]:"";
            b[appObj.dataIndex]=b[appObj.dataIndex]?b[appObj.dataIndex]:"";
            return a[appObj.dataIndex].localeCompare(b[appObj.dataIndex]);
          },
        };
        appObj.title = patientProperties.label;
        appObj.dataIndex = patientProperties.columnName;
        appObj.key = patientProperties.columnName;
        tempcoldata.push(appObj);
      });
      setColumn(tempcoldata);
      const tempData : any = [];
      let totalAppointmentSum = 0 ;
      forEach(patientDayAppointmentDetails, (singleAppointment) => {
        if (singleAppointment) {
          let appObj: any = {};
          forEach(singleAppointment, (patientProperties) => {
            if(patientProperties.columnName === "appointment_amount"){
              totalAppointmentSum = totalAppointmentSum +  patientProperties.value;
            }
            appObj[patientProperties.columnName] = patientProperties.value;
          });
          tempData.push(appObj)
        }
      });
      setTotalAppointmentAmount(totalAppointmentSum);
      setAppointmentInfodata(tempData);
      setData(tempData)
  }, [patientDayAppointmentDetails]);
  

  const applyColumnSearch = (columnName: any, text: any) => {
    text = text
        ? text
        : get(columnSearchInfo, [columnName], "");
    if(text !== ""){
      let tempAppointmentInfodata = data.filter((data:any) => {
        if(data[columnName]){
         return data[columnName].toString().toLowerCase().includes(text.toLowerCase()) 
        }else{
          return false
        }
      })
    setAppointmentInfodata(tempAppointmentInfodata)
    }else{
      setAppointmentInfodata(data)
    }
  };
  
  const inputref = useRef<any>(null);
   const _xyz: Array<{}> = map(cloneDeep(column), (dataInfo: any) => {
    return {
      ...dataInfo,
  
      filterDropdown:
        ({ confirm }: any) => (
              <div style={{ padding: "10px" }}>
                <Input
                  style={{ marginBottom: 8, display: "block" }}
                  value={get(columnSearchInfo, dataInfo.dataIndex, "")}
                  ref={inputref}
                  onChange={(e) => {
                    e.preventDefault();
                    setColumnSearchInfo({
                      ...columnSearchInfo,
                      [dataInfo.dataIndex]: e.target.value,
                    });
                  }}
                  onKeyUp={(e) => {
                    if (e.keyCode === 13) {
                      e.preventDefault();
                      setColumnSearchInfo({
                        [dataInfo.dataIndex]: get(
                          columnSearchInfo,
                          dataInfo.dataIndex,
                          ""
                        ),
                      });
                      applyColumnSearch(dataInfo.dataIndex, "");
                      confirm({ closeDropdown: true });
                    }
                  }}
                />
                <Space>
                  <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setColumnSearchInfo({
                        [dataInfo.dataIndex]: get(
                          columnSearchInfo,
                          dataInfo.dataIndex,
                          ""
                        ),
                      });
                      applyColumnSearch(dataInfo.dataIndex, "");
                      confirm({ closeDropdown: true });
                    }}
                  >
                    Search
                  </Button>
                  <Button
                    onClick={() => {
                      setColumnSearchInfo({ [dataInfo.dataIndex]: "" });
                      applyColumnSearch("", "");
                      confirm({ closeDropdown: true });
                    }}
                    size="small"
                    style={{ width: 90 }}
                  >
                    Reset
                  </Button>
                </Space>
              </div>
            ),
            onFilterDropdownOpenChange: (visible:any) => {
              if (visible) {
                setTimeout(() => inputref.current?.select(), 100);
              }
            },
      filterIcon:
        dataInfo.dataIndex === "action"
          ? null
          : () => (
              <SearchOutlined
                style={{
                  color:
                    get(columnSearchInfo, dataInfo.dataIndex, "") !== ""
                      ? "#EF6D2A"
                      : undefined,
                }}
              />
            ),
      render:
      dataInfo.dataIndex === "date"
      ? dataInfo.render : 
        ["appointment_date","appointment_created_date","first_proc_date"].includes(dataInfo.dataIndex) ? 
          (text: any, record: any) =>
          dateDiv(
                text,
                get(columnSearchInfo, dataInfo.dataIndex, ""),
                record
              )
          : (text: any, record: any) =>
              highlighterDiv(
                text = dataInfo.dataIndex === "appointment_amount" ? `$ ${text}`:text,
                get(columnSearchInfo, dataInfo.dataIndex, ""),
                record
              ),
      onFilter: (value: any, record: any) =>
        record[dataInfo.dataIndex]
          ? record[dataInfo.dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
          : "",
    };
  });

    return appointmentInfoLoading ? (
      <TablePreloader />
    ) : (
      <div>
        <Card>
        <div className="totalAppointmentAmount"><div>Total Appointment Amount <div className="totalAppointmentAmount__subtitle">(Includes broken appointments) </div></div><div className="totalAppointmentAmount__value">: $ {totalAppointmentAmount.toLocaleString()}</div></div>
          <Row>
            <Col span={24}>
              <div className="appointment-table">
                <Table
                  bordered={true}
                  pagination={{
                    defaultPageSize: 5,
                    showSizeChanger: true,
                    pageSizeOptions: ["5", "10", "15", "20", "25", "30"],
                  }}
                  // loading={loading}
                  columns={_xyz}
                  dataSource={appointmentInfodata}
                  locale={TableLocale}
                  scroll={{ x: 1200 }}
                  // size="small"
                  onRow={(record, rowIndex) => {
                    return {
                      className:
                      record.appointment_date === formatCreateDate(selectedDateCalender)
                          ? `ui-population-insight__body__report__table__row--selected`
                          : undefined,
                    };
                  }}
                />
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    );
}

export default AppointmentInfo;